import firebase from 'firebase'
export const PERFORM_LOGIN = 'PERFORM_LOGIN'
export const PERFORM_LOGIN_SUCCESS = 'PERFORM_LOGIN_SUCCESS'
export const PERFORM_LOGIN_FAIL = 'PERFORM_LOGIN_FAIL'

export const PERFORM_INPUT_LOGIN = 'PERFORM_INPUT_LOGIN'
export const PERFORM_INPUT_PASSWORD = 'PERFORM_INPUT_PASSWORD'

export const CLEAR_LOGIN_FORM = 'CLEAR_LOGIN_FORM'




export const performLogin = () => (dispatch, getState) => {

    const reducerState = getState().ReducerLogin

    firebase.auth()
        .signInWithEmailAndPassword(reducerState.login, reducerState.password)
        .then(resp => {
            dispatch(loginSuccess(resp))
        })
        .catch(error => {
            dispatch(loginFail(error))
        })
    return {
        type: PERFORM_LOGIN
    }
}

export const loginSuccess = () => {
    return {
        type: PERFORM_LOGIN_SUCCESS
    }
}

export const loginFail = () => {
    return {
        type: PERFORM_LOGIN_FAIL
    }
}

export const clearForm = () => {
    return {
        type: CLEAR_LOGIN_FORM
    }
}

export const performInputLogin = (login) => ({
    type: PERFORM_INPUT_LOGIN,
    payload: login
})
export const performInputPassword = (password) => ({
    type: PERFORM_INPUT_PASSWORD,
    payload: password
})


// WEBPACK FOOTER //
// ./src/Actions/ActionsLogin.js